import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { SideNavAccordionItem, SideNavAccordionList } from 'teacher-ui-client/components/side-nav/accordion'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'
import { t } from 'ember-intl'
import graphUnfilled from '@images/icons/graph-unfilled.svg'

export class MathseedsPrimeReportsAccordion extends Component<unknown> {
  @service sideNav!: SideNavService

  get uiScopeModels() {
    return this.sideNav.uiScopeModels ?? []
  }

  <template>
    <SideNavAccordionList
      data-test-side-nav-mathseeds-prime-reports
      @iconUrl={{graphUnfilled}}
      @iconAlt="Sidenav bar"
      @label={{t "sideNav.reports.title"}}
    >
      <SideNavAccordionItem
        data-test-mathseeds-prime-link-dashboard
        @route="reporting.ui-scope.mathseeds-prime.dashboard-table"
        @currentWhen="reporting.ui-scope.mathseeds-prime.dashboard-table reporting.ui-scope.mathseeds-prime.dashboard-student"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="mathseeds-prime" page="dashboard"}}
      >{{t "sideNav.reports.dashboard"}}</SideNavAccordionItem>
    </SideNavAccordionList>
  </template>
}

export default MathseedsPrimeReportsAccordion
